<template>
  <div class="announcement-detail p-3">
    <div class="mb-4">
      <b-button variant="link" class="p-0 text-decoration-none" @click="$router.back()">
        <i class="fas fa-arrow-left mr-1"></i> {{ $t('dashboard-announcements.button-back') }}
      </b-button>
    </div>

    <div v-if="loading" class="text-center p-5">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <b-card v-else-if="announcement" class="shadow-sm border-0">
      <div class="border-bottom pb-3 mb-4">
        <h2 class="h3 font-weight-bold mb-2">{{ announcement.title }}</h2>
        <div class="text-muted small">
          <i class="far fa-clock mr-1"></i> {{ formatDate(announcement.created_at) }}
        </div>
      </div>

      <div class="announcement-content mb-5 white-space-pre-wrap lead-text">
        {{ announcement.body }}
      </div>

      <div v-if="announcement.attachment_url" class="attachment-section p-4 bg-light rounded border">
        <h6 class="font-weight-bold mb-3"><i class="fas fa-paperclip mr-2 text-info"></i>{{ $t('dashboard-announcements.label-attachment') }}</h6>
        <b-button :href="announcement.attachment_url" target="_blank" variant="info">
          <i class="fas fa-download mr-1"></i> {{ $t('dashboard-announcements.button-download') }}
        </b-button>
      </div>
    </b-card>

    <div v-else class="text-center p-5 text-muted">
      {{ $t('dashboard-announcements.message-not-found') }}
    </div>
  </div>
</template>

<script>
import announcementApi from "@/api/announcements";
import moment from "moment";

export default {
  name: "AnnouncementDetail",
  props: ["id"],
  data() {
    return {
      loading: false,
      announcement: null
    };
  },
  methods: {
    async fetchDetail() {
      try {
        this.loading = true;
        const response = await announcementApi.getAnnouncement(this.id);
        this.announcement = response.data.announcement;

        // 取得時点で未読だった場合のみ既読化＋バッジを1減算する。
        // すでに既読の詳細を再表示しても DECREMENT しないので過剰減算にならない。
        // unmounted 後の commit を防ぐため await して fetchDetail の完了を待つ。
        if (this.announcement && !this.announcement.is_read) {
          await this.markAsRead();
        }
      } catch (error) {
        console.error("Failed to fetch announcement detail:", error);
      } finally {
        this.loading = false;
      }
    },
    async markAsRead() {
      try {
        await announcementApi.readAnnouncements([this.id]);
        this.$store.commit("dashboard/decrement_unread_count");
      } catch (error) {
        // Silently fail for read status
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    }
  },
  mounted() {
    this.fetchDetail();
  }
};
</script>

<style scoped>
.white-space-pre-wrap {
  white-space: pre-wrap;
}
.lead-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
}
</style>
